import React from 'react'
import currency from 'currency.js'
import { type WebProduct } from '../../common/types/webshop.types';
import { formatCurrency } from '../../common/js/currency-utility';
import { useTranslation } from 'react-i18next';

type Props = {
    onSelect: Function,
    selected: string,
    isSalePrice: boolean,
    monthlyVariant: WebProduct,
    annualVariant: WebProduct,
    currencyIso: string
}

export default function SubscriptionSelect(props: Props) {
    const {
        onSelect,
        selected,
        isSalePrice,
        monthlyVariant,
        annualVariant,
        currencyIso
    } = props;
    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        onSelect(event);
    }

    const { t } = useTranslation(['checkout', 'common'])

    const monthlyClass = selected == 'New Monthly Subscription' ? 'subscription-option selected' : 'subscription-option';
    const annualClass = selected == 'New Annual Subscription' ? 'subscription-option selected' : 'subscription-option';

    let monthly,
        monthlyList,
        annual,
        annualMonthly,
        annualList;

    if (annualVariant){
        const annualFloat = currency(annualVariant.prices[currencyIso]);
        const annualMonthlyFloat = currency(annualFloat).divide(12);
        const annualListFloat = currency(annualVariant.listPrices[currencyIso]);
        annual = formatCurrency(annualFloat, currencyIso);
        annualMonthly = formatCurrency(annualMonthlyFloat, currencyIso);
        annualList = formatCurrency(annualListFloat, currencyIso);
    }
    if (monthlyVariant){
        const monthlyFloat = currency(monthlyVariant.prices[currencyIso]);
        const monthlyListFloat = currency(monthlyVariant.listPrices[currencyIso]);
        monthly = formatCurrency(monthlyFloat, currencyIso);
        monthlyList = formatCurrency(monthlyListFloat, currencyIso);
    }

    return (
        <div className="plan-pricing">
            <div className="plan-item">
                <div data-name="New Annual Subscription" className={annualClass} onClick={handleClick}>
                    <strong className="best-value">{t('purchase.bestValue')}</strong>
                    <span className="title">{t('purchase.subTypes.annualSubscription')}</span>
                    <div className='price-over'>
                        {!isSalePrice && (
                            <>
                                <div className={'price-total'}>{annual}&nbsp;</div>
                                <div className="price-month">({annualMonthly}/{t('purchase.monthAbbr')} {t('basic.for', {ns: "common"})} 12 {t('purchase.monthAbbr')}.)</div>
                            </>
                        )}
                        {isSalePrice && (
                            <>
                                <div className='price-total'><span className='price-total-discount'>{annual} ({annualMonthly}/{t('purchase.monthAbbr')} {t('basic.for', {ns: "common"})} 12 {t('purchase.monthAbbr')})</span></div>
                                <div className='annual-list-price'>{annualList}</div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div className="plan-item">
                <div data-name="New Monthly Subscription" className={monthlyClass} onClick={handleClick}>
                    <span className="title">{t('purchase.subTypes.monthlySubscription')}</span>
                    <div className='price-over'>
                        {!isSalePrice && (
                            <>
                                <div className='price-total'>{monthly}/{t('purchase.monthAbbr')}&nbsp;</div>
                                <div className="price-month"></div>
                            </>
                        )}
                        {isSalePrice && (
                            <>
                                <div className='price-total'><span className='price-total-discount'>{monthly}</span></div>
                                <div className="price-month price-month-discount"><p style={{margin: 0, display: 'inline-block', verticalAlign: 'bottom'}}>({t('purchase.renewsAt')} {monthlyList}/{t('purchase.monthAbbr')})</p></div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
